export default __webpack_public_path__ + "content/media/13.1eb8fe16.jpg";